import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable, Optional } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { HelpLibraryService } from "../services/help-library.service";
import { HelpItem } from "../models/help-library.model";
import { LoaderService } from "../../common/services/loader.service";

@Injectable()
export class HelpLibraryEditorResolver  {

    constructor(
        public helpService: HelpLibraryService,
        @Optional() public _loader: LoaderService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<HelpItem> {
        return this.helpService.getHelp(route.parent.params.id, route.parent.params.categoryId)
            .pipe(tap((data) => {
                if (this._loader) {
                    this._loader.toggleLoader(false);
                }
                this.helpService.setActiveNavItem(data);
            }));
    }
}